/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { FileResponse } from '../model';
/**
 * AdminFileControllerApi - axios parameter creator
 * @export
 */
export const AdminFileControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UploadImageImageTypeEnum} imageType 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage: async (imageType: UploadImageImageTypeEnum, file: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageType' is not null or undefined
            assertParamExists('uploadImage', 'imageType', imageType)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadImage', 'file', file)
            const localVarPath = `/admin/files/images/{imageType}`
                .replace(`{${"imageType"}}`, encodeURIComponent(String(imageType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminFileControllerApi - functional programming interface
 * @export
 */
export const AdminFileControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminFileControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {UploadImageImageTypeEnum} imageType 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadImage(imageType: UploadImageImageTypeEnum, file: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadImage(imageType, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminFileControllerApi - factory interface
 * @export
 */
export const AdminFileControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminFileControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {UploadImageImageTypeEnum} imageType 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage(imageType: UploadImageImageTypeEnum, file: File, options?: any): AxiosPromise<FileResponse> {
            return localVarFp.uploadImage(imageType, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminFileControllerApi - object-oriented interface
 * @export
 * @class AdminFileControllerApi
 * @extends {BaseAPI}
 */
export class AdminFileControllerApi extends BaseAPI {
    /**
     * 
     * @param {UploadImageImageTypeEnum} imageType 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFileControllerApi
     */
    public uploadImage(imageType: UploadImageImageTypeEnum, file: File, options?: AxiosRequestConfig) {
        return AdminFileControllerApiFp(this.configuration).uploadImage(imageType, file, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const UploadImageImageTypeEnum = {
    Meal: 'MEAL',
    Plan: 'PLAN'
} as const;
export type UploadImageImageTypeEnum = typeof UploadImageImageTypeEnum[keyof typeof UploadImageImageTypeEnum];
